module.exports = __webpack_public_path__ + "static/media/6areas.8c661a53.png";